"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alloc8Client = exports.GetAlloc8BranchesResponse = exports.CreateAlloc8EmployeeRequest = exports.UpsertAlloc8ConfigRequest = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const designed_1 = require("designed");
const ResponseBase_1 = require("../ResponseBase");
const handler_1 = require("../utils/handler");
class UpsertAlloc8ConfigRequest extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, tslib_1.__metadata)("design:type", String)
], UpsertAlloc8ConfigRequest.prototype, "apiKey", void 0);
exports.UpsertAlloc8ConfigRequest = UpsertAlloc8ConfigRequest;
class CreateAlloc8EmployeeRequest extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, tslib_1.__metadata)("design:type", String)
], CreateAlloc8EmployeeRequest.prototype, "memberId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], CreateAlloc8EmployeeRequest.prototype, "primaryBranchId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsInt)(),
    (0, tslib_1.__metadata)("design:type", Number)
], CreateAlloc8EmployeeRequest.prototype, "employmentStatusId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsOptional)(),
    (0, tslib_1.__metadata)("design:type", Number)
], CreateAlloc8EmployeeRequest.prototype, "minimumHours", void 0);
exports.CreateAlloc8EmployeeRequest = CreateAlloc8EmployeeRequest;
class Branch extends designed_1.Entity.Base {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, tslib_1.__metadata)("design:type", String)
], Branch.prototype, "id", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, tslib_1.__metadata)("design:type", String)
], Branch.prototype, "name", void 0);
class GetAlloc8BranchesResponse extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field({ entity: Branch }),
    (0, class_validator_1.IsInstance)(Branch, { each: true }),
    (0, tslib_1.__metadata)("design:type", Array)
], GetAlloc8BranchesResponse.prototype, "branches", void 0);
exports.GetAlloc8BranchesResponse = GetAlloc8BranchesResponse;
class Alloc8Client {
    constructor(http, $error) {
        this.http = http;
        this.$error = $error;
        this.upsertAlloc8Config = (0, handler_1.handler)(this, async (args) => this.http
            .request()
            .to("/alloc8/config")
            .bodyJSON(UpsertAlloc8ConfigRequest.create(args))
            .post());
        this.createAlloc8Employee = (0, handler_1.handler)(this, async (args) => this.http
            .request()
            .to("/alloc8/employee")
            .bodyJSON(CreateAlloc8EmployeeRequest.create(args))
            .post());
        this.getAlloc8Branches = (0, handler_1.handler)(this, async () => this.http
            .request()
            .to("/alloc8/branches")
            .get((d) => GetAlloc8BranchesResponse.create(d)));
    }
}
exports.Alloc8Client = Alloc8Client;
